import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from "@/App"
import Input from "@/components/Input"
import Button from "@/components/Button"
import { Link } from 'react-router-dom'
import { HiChevronDown, HiChevronUp, HiTrash as TrashIcon } from "react-icons/hi2";
import api from '../api'

export default function CartSummary({ subtotal, charges, discounts, onCheckout }) {
	const {user} = useContext(UserContext)
	const chargesTotal = charges.reduce((sum, c) => sum + c.amount, 0)
	const discountTotal = discounts.reduce((sum, d) => sum + d.amount, 0)
	const [allCoupons, setAllCoupons] = useState([]);
	const [couponApplied, setCouponApplied] = useState(false);
	const [showCouponDropdown, setShowCouponDropdown] = useState(false);
	const [couponCode, setCouponCode] = useState("");
	const [couponId, setCouponId] = useState(0);
    const [discountId, setDiscountId] = useState(0);
	const [discount, setDiscount] = useState(0);
		
	 useEffect(() => {
		if (!user) return;
	  // Fetch coupons from backend
	  const fetchCoupons = async () => {
		try {
			console.log("user",user)
		  const res = await api.getCoupons(user._id);
		//   console.log("coupon response",res)
		  const enriched = res.map((coupon) => {
			const isExpired = new Date(coupon.expiry) < new Date();
			const isUsed = coupon.isUsed;
			let isMinNotMet;
			if(coupon.minCartValue>0){
			isMinNotMet = subtotal < coupon.minCartValue;
			}
			let status = "available";
			if (isExpired) status = "expired";
			else if (isUsed) status = "used";
			else if (isMinNotMet) status = "minValueNotMet";
			return { ...coupon, status };
		  });
		  console.log("enriched coupons",enriched)
		  setAllCoupons(enriched);
		} catch (err) {
		  console.log("Failed to fetch coupons", err);
		}
	  };
	
	  fetchCoupons();
	}, [user]);

	 const handleApplyCoupon = async (coupon_id) => {
  try {
	const couponDetails= {
      id:coupon_id,
      code: couponCode,
      total:Number(subtotal),
      userId: user.id,
      qty:1,
	}
    const res = await api.validateCoupon(couponDetails); 

    console.log("coupon validate",res)

    if (res.discountAmount) {
      // const { value, discountType } = res.data.coupon;

      const discountAmount =res.discountAmount
        // discountType === "percentage"
        //   ? Math.round((subtotal * value) / 100)
        //   : value;

      setDiscount(discountAmount);
      setCouponApplied(true);
	//   const updatedData = {
	// 	couponAmount:discountAmount
	//   }
	//   const updatedCart = await api.updateCart(updatedData);
	//   console.log("data added in cart",updatedCart);
    //   alert(`Coupon applied! You saved ₹${discountAmount}`);
    }
  } catch (err) {
	console.log(err);
    alert(err.response?.data?.msg || "Invalid coupon error");
  }
};

const handleCheckout = async (e) => {
e.preventDefault();
    try {
      await onCheckout(discount,chargesTotal);
    } catch (err) {
        setError("Could not checkout: " + err.message);
    }
}

	return (
		<div className="flex flex-col p-4 space-y-4">
			<h2 className="uppercase text-3xl">Cart Summary</h2>
			<div className="border-t border-b border-gray-200 space-y-4 py-4">
				<div className="flex justify-between text-lg">
					<span>Subtotal</span>
					<span>₹{subtotal}</span>
				</div>
				{charges.map(charge => (
					<div className="flex justify-between" key={charge.name}>
						<span>{charge.name}</span>
						<span>₹{charge.amount}</span>
					</div>
				))}
				{discounts.map(discount => (
					<div className="flex justify-between" key={discount.name}>
						<span>{discount.name}</span>
						<span>-₹{discount.amount}</span>
					</div>
				))}

				{couponApplied && (
                <div className="flex justify-between text-green-700">
                  <span>Coupon Discount</span>
                  <span>- ₹{discount.toFixed(2)}</span>
                </div>
              )}

			  {couponApplied && (
				<div className="flex items-center justify-between mt-2">
					<p className="text-sm text-green-600">
					Applied Coupon: <strong>{couponCode}</strong>
					</p>
					<button
					onClick={() => {
						setCouponApplied(false);
						setCouponCode("");
						setDiscount(0);
						setCouponId(0);
						setDiscountId(0);
						// toast("Coupon removed.");
					}}
					className="text-xs text-red-500 underline"
					>
					Remove
					</button>
				</div>
				)}

				<div className="flex justify-between font-medium text-2xl">
					<span>Total</span>
					<span>₹{(Number(subtotal) + Number(chargesTotal) - Number(discountTotal) - Number(discount))?.toFixed(2)}</span>
				</div>
			</div>

				<div className="flex justify-between">
					<Input placeholder="Coupon Code" className="!min-w-20" 
					value={couponCode} onChange={(e) => setCouponCode(e.target.value)}/>
					<Button secondary onClick={() => handleApplyCoupon(couponId)}>Apply</Button>
				</div>
						{/*Dropdown Toggle */}
						<div className="mt-2">
						<button
							className="text-black text-sm"
							onClick={() => setShowCouponDropdown((prev) => !prev)}
						><div className="flex items-center justify-between gap-2 cursor-pointer">
						<span className="text-base font-medium">Available Coupons</span>
						{showCouponDropdown ? <HiChevronUp /> : <HiChevronDown />}
						</div>
						</button>
						</div>
	
					    {/*Dropdown Slide Panel */}
					    {showCouponDropdown && (
					    <div className="mt-3 bg-gray-50 border rounded p-3 max-h-[300px] overflow-auto shadow">
					    	{/* <h4 className="text-sm font-semibold mb-2">Available Coupons</h4> */}
					    	{allCoupons.filter(c => c.status == "available").length == 0 && (
					    	<p className="text-sm text-gray-500">No available coupons</p>
					    	)}
					    	{allCoupons
					    .filter((c) => c.status == "available")
					    .map((coupon) => (
					    	<div
					    	key={coupon.name}
					    	className="flex justify-between items-center py-2 border-b"
					    	>
					    	<div>
					    		<p className="font-medium">{coupon.name}</p>
					    		<p className="text-xs text-gray-500">{coupon.couponDesc}</p>
					    		{/* <p className="text-xs text-gray-500">
					    		{coupon.discountType === "percentage"
					    			? `${coupon.value}% off`
					    			: `₹${coupon.value} off`}
					    		</p> */}
					    	</div>
	    
					    	<button
					    		className={`text-sm px-2 py-1 rounded ${
					    		couponCode === coupon.name
					    			? "bg-green-600 text-white"
					    			: "bg-green-500 text-white"
					    		}`}
					    		onClick={() => {
					    setCouponCode(coupon.name);
					    setCouponId(coupon.id);
					    setDiscountId(coupon.discountId);   // Just fill the code in input
					    setCouponApplied(false);           // Clear the applied state
					    setDiscount(0);                    // Clear the discount
					    setShowCouponDropdown(false);     // close dropdown
					    }}
					    >
					    	{couponCode === coupon.name ? "Selected" : "Select"}
					    	</button>
					    	</div>
					    ))}
					    </div>
					    )}

			<Button className="w-full self-center" onClick={handleCheckout} disabled={!user}>Checkout Now</Button>
			{!user && 
				<Link to="/register" className='text-sm text-gray-600 text-center'>
					Please login or register to checkout
				</Link>
			}
		</div>
	)
}